import { CriteriaBase } from '@/shared/models/CriteriaBase.model';
import { EtatIntrant } from '@/shared/enums/EtatIntrant.enum';
import { EtatDeclarationIntrantProducteur } from '@/shared/enums/EtatDeclarationIntrantsProducteur.enum';
// Énumérations.
import { ArreteTarifaireCode } from '@/shared/enums/ArreteTarifCode.enum';
import { EStatutPDP } from '@/shared/enums/EStatutPdp.enum';

/**
 * Liste des filtres possible pour récupérer la liste des déclarations d'intrant.
 */
export class IntrantCriteria extends CriteriaBase {
    /**
     * L'ensemble des contrats d'achat (installations) liés aux intrants.
     */
    public contratAchatGroupeIds: number[];

    /**
     * L'année de déclaration de l'intrant.
     */
    public annee: number;

    /**
     * Filtre sur les états des intrants.
     */
    public etatIntrants?: EtatIntrant;

    /**
     * Filtre sur les états des intrants pour les producteurs.
     */
    public etatIntrantsProducteur?: EtatDeclarationIntrantProducteur;

    /**
     * Filtre sur Code Arrêté Tarifaire.
     */
    public codeArreteTarifaire?: ArreteTarifaireCode;

    /**
     * Le statut de la recherche par Statut Pdp.
     */
    public statutFiltrePDP: EStatutPDP;

    /**
     * Initialise les valeurs par défaut du filtre de factures.
     */
    constructor() {
        super();
        this.contratAchatGroupeIds = [];
        this.etatIntrants = undefined;
        this.etatIntrantsProducteur = undefined;
        // Année précédente par défaut.
        this.annee = new Date().getFullYear() - 1;
        this.codeArreteTarifaire = undefined;
    }
}
